"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetYourFreeHoaAssessment() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: captionRef,
    isVisible: captionVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  return <section data-section-id="4535" id="get-your-free-hoa-assessment" className="bg-background text-foreground relative w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697657/img/arborist_assessment_site.png)]" />

      {}
      <div className="absolute inset-0" style={{
      background: "linear-gradient(135deg, hsla(30, 15%, 15%, 0.9) 0%, hsla(30, 15%, 20%, 0.7) 50%, hsla(30, 15%, 15%, 0.8) 100%)"
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative z-10 mx-auto flex max-w-[800px] flex-col items-center px-6 py-32 text-center md:py-44 lg:py-[180px]">
        {}
        <div ref={labelRef} className={`mb-12 transition-all duration-700 ease-out md:mb-16 ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-mono text-xs tracking-[0.25em] text-primary uppercase">
            05 — Assessment
          </span>
        </div>

        {}
        <h2 ref={headingRef} className={`font-serif font-default text-white leading-[0.95] tracking-tight transition-all duration-1000 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        fontFamily: "var(--font-serif)",
        fontWeight: 400,
        fontSize: "clamp(3.5rem, 10vw, 8.75rem)"
      }}>
          Request your
          <span className="inline-flex items-center px-3 align-middle md:px-5">
            <span className="inline-block h-[1px] bg-primary" style={{
            width: "clamp(2.5rem, 6vw, 5rem)",
            transform: "rotate(-20deg)"
          }} />
          </span>
          assessment.
        </h2>

        {}
        <p ref={bodyRef} className={`mt-10 max-w-[560px] text-base leading-relaxed text-gray-200 transition-all duration-1000 delay-150 ease-out md:text-lg ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        fontFamily: "var(--font-default)"
      }}>
          Protect your community's canopy with a professional evaluation. Our certified arborists provide detailed health reports and maintenance strategies tailored to your HOA's unique landscape requirements.
        </p>

        {}
        <div ref={ctaRef} className={`mt-12 flex flex-col items-center gap-6 transition-all duration-1000 delay-300 ease-out sm:flex-row sm:gap-8 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild size="lg" className="group h-auto rounded-lg bg-primary px-8 py-4 text-base font-medium text-primary-foreground shadow-lg hover:bg-primary/90">
            <Link to="/GetQuotePage">
              Schedule Your Assessment
              <ArrowRight className="ml-1 size-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>

          <Link to="/CommunitiesWeServePage" className="group inline-flex items-center gap-2 border-b border-white/40 pb-1 text-sm font-medium tracking-wide text-white transition-colors hover:border-white">
            View Our Communities
            <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>

          <Link to="/HomePage" className="group inline-flex items-center gap-2 border-b border-white/40 pb-1 text-sm font-medium tracking-wide text-white transition-colors hover:border-white">
            Home
            <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>

        {}
        <p ref={captionRef} className={`mt-16 font-mono text-[11px] tracking-[0.2em] text-gray-400 uppercase transition-all duration-1000 delay-500 ease-out md:text-xs ${captionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Expert Consultation — 24 Hour Scheduling / Regional Arborist Teams
        </p>
      </div>
    </section>;
}